//This is a page to display the files uploaded to the file system
import React, { useState, useEffect } from 'react';
import { Container, Card, FormSelect, InputGroup } from 'react-bootstrap';
import FileCard from './FileCard';
import FileUpload from './FileUpload';
import { PHP, API } from '../../utils/axiosConfig';
import LoadingOverlay from '../../components/LoadingOverlay';
import './fileRepo.scss';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

function FileRepo() {
	const { user } = useAuth();
	const php = PHP();
	const api = API();
	const [files, setFiles] = useState([]);
	const [loading, setLoading] = useState(true);
	const [users, setUsers] = useState([]);
	const [selectedUser, setSelectedUser] = useState();

	useEffect(() => {
		console.log('user useEffect firing, fetching files');
		// Fetch the list of files from the server
		fetchFiles();
		//If the user is an admin, fetch all the users in the system to manage their files
		if (user && user.userLevel === 'admin') {
			fetchUsers();
		}
	}, [user]);

	useEffect(() => {
		console.log({ selectedUser });
	}, [selectedUser]);

	const fetchFiles = (userID) => {
		let formData = new FormData();
		formData.append('listRequest', 1);
		//Pass the userID of the selected user to view user files as admin
		if (userID) {
			formData.append('userID', userID);
		} else if (selectedUser) {
			formData.append('userID', selectedUser._id);
		}
		//TODO: need to pass user authentication for requested files to start server session
		console.log({ formData });
		php
			.post('fileRepo.php', formData)
			.then((res) => {
				if (Array.isArray(res.data)) {
					setFiles(res.data);
				}
				setLoading(false);
			})
			.catch((error) => {
				console.error('Error fetching files:', error);
				setLoading(false);
			});
	};

	const fetchUsers = () => {
		api
			.get('/users/getAllUsers')
			.then((res) => {
				if (res.status === 200) {
					setUsers(res.data.users);
				}
			})
			.catch((err) => console.log(err));
	};

	const handleUserSelect = (e) => {
		const userID = e.target.value;
		const selected = users.find((user) => user._id === userID);
		setSelectedUser(selected);
		setLoading(true);
		fetchFiles(userID);
	};

	return (
		<div id="file-repo" className="page">
			<Container fluid>
				<Card className="shadow-card">
					<Card.Body>
						<div
							className={
								user && user.userLevel
									? 'd-flex justify-content-end'
									: 'd-flex justify-content-between'
							}
						>
							{user && user.userLevel === 'admin' && (
								<InputGroup>
									<InputGroup.Text>
										<FontAwesomeIcon icon={faUser} />
									</InputGroup.Text>

									<FormSelect
										id="user-select"
										name="user"
										onChange={handleUserSelect}
									>
										{users.map((user, i) => {
											return (
												<option key={i} value={user._id}>
													{user.lastName}, {user.firstName}
												</option>
											);
										})}
									</FormSelect>
								</InputGroup>
							)}
							<FileUpload
								useModal={true}
								callback={fetchFiles}
								selectedUser={selectedUser}
							/>
						</div>

						{loading ? (
							<LoadingOverlay />
						) : (
							<>
								<div className="d-flex">
									<div className="file-cards">
										{files.map((file, i) => (
											<FileCard key={i} file={file} fetchFiles={fetchFiles} />
										))}
										{files.length === 0 && (
											<h1 className="text-center">No uploaded files.</h1>
										)}
									</div>
								</div>
							</>
						)}
					</Card.Body>
				</Card>
			</Container>
		</div>
	);
}

export default FileRepo;
